import { ArrowBack } from '@mui/icons-material'
import { Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

function ButtonBack() {
const navigate =  useNavigate();

const handleNavigate=()=>{
    navigate(-1);
}
  return (
    <>
        <Button
          variant="contained"
          startIcon={<ArrowBack size={20} color="inherit" />}
          color="warning"
          onClick={handleNavigate}
        >
          Cancelar
        </Button>
      
    </>
  )
}

export default ButtonBack
